<ion-content>
  <ion-grid>
    <!-- Header with Admin Controls -->
    <ion-row>
      <ion-col>
        <ion-card>
          <ion-card-header>
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <div>
                <ion-card-title
                  >Knowledge Gap Insights - Admin Panel</ion-card-title
                >
                <ion-card-subtitle *ngIf="selectedTenant">
                  {{ selectedTenant.name }} ({{ selectedTenant.id }})
                </ion-card-subtitle>
              </div>
              <div style="display: flex; gap: 0.5rem">
                <ion-button
                  fill="solid"
                  color="primary"
                  size="small"
                  (click)="triggerAnalysis()"
                  [disabled]="isLoading"
                >
                  <ion-icon name="play" slot="start"></ion-icon>
                  Trigger Analysis
                </ion-button>
                <ion-button
                  fill="outline"
                  color="danger"
                  size="small"
                  (click)="resetData()"
                  [disabled]="isLoading"
                >
                  <ion-icon name="trash" slot="start"></ion-icon>
                  Reset Data
                </ion-button>
                <ion-button fill="outline" size="small" (click)="onRefresh()">
                  <ion-icon name="refresh" slot="start"></ion-icon>
                  Refresh
                </ion-button>
                <ion-button
                  fill="clear"
                  size="small"
                  (click)="goBackToTenantSelection()"
                >
                  <ion-icon name="arrow-back" slot="start"></ion-icon>
                  Back
                </ion-button>
              </div>
            </div>
          </ion-card-header>
        </ion-card>
      </ion-col>
    </ion-row>

    <!-- Error Message -->
    <ion-row *ngIf="error">
      <ion-col>
        <ion-card color="danger">
          <ion-card-content>
            <ion-icon name="alert-circle" slot="start"></ion-icon>
            {{ error }}
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>

    <!-- Statistics -->
    <ion-row *ngIf="stats">
      <ion-col>
        <ion-card>
          <ion-card-header>
            <ion-card-title>Statistics</ion-card-title>
          </ion-card-header>
          <ion-card-content>
            <div style="display: flex; gap: 2rem; flex-wrap: wrap">
              <div style="text-align: center">
                <h2>{{ stats.total }}</h2>
                <p>Total Insights</p>
              </div>
              <div
                *ngFor="let category of getCategoryNames()"
                style="text-align: center"
              >
                <h3>{{ stats.byCategory[category] }}</h3>
                <p>{{ category }}</p>
              </div>
            </div>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>

    <!-- Filters and Search -->
    <ion-row>
      <ion-col>
        <div class="filter-controls">
          <ion-searchbar
            mode="ios"
            placeholder="Search insights..."
            showCancelButton="never"
            class="rounded-search-bar"
            [(ngModel)]="searchText"
            (ionChange)="onSearch()"
          >
          </ion-searchbar>

          <div
            style="
              display: flex;
              gap: 1rem;
              align-items: center;
              flex-wrap: wrap;
              margin-top: 1rem;
            "
          >
            <ion-input
              placeholder="Project ID (optional)"
              [(ngModel)]="selectedProjectId"
              (ionChange)="applyFilters()"
              style="min-width: 200px"
            ></ion-input>

            <ion-button fill="clear" (click)="clearFilters()">
              <ion-icon name="close" slot="start"></ion-icon>
              Clear
            </ion-button>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <!-- Loading State -->
    <ion-row *ngIf="isLoadingInsights">
      <ion-col>
        <div class="loading-container">
          <ion-spinner></ion-spinner>
          <p>Loading insights...</p>
        </div>
      </ion-col>
    </ion-row>

    <!-- Insights List -->
    <ion-row *ngIf="!isLoadingInsights && insights.length > 0">
      <ion-col>
        <div>
          <ion-card
            *ngFor="let insight of insights; trackBy: trackByInsight"
            class="insight-card"
          >
            <ion-card-header>
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                "
              >
                <ion-card-title>{{ insight.category }}</ion-card-title>
                <ion-button
                  fill="clear"
                  size="small"
                  color="medium"
                  (click)="toggleInsightExpansion(insight)"
                >
                  <ion-icon
                    [name]="
                      selectedInsight?.id === insight.id
                        ? 'chevron-up'
                        : 'chevron-down'
                    "
                  ></ion-icon>
                </ion-button>
              </div>
            </ion-card-header>

            <ion-card-content>
              <p>{{ getSynopsis(insight) }}</p>

              <!-- Basic metadata -->
              <div
                style="
                  display: flex;
                  gap: 1rem;
                  margin: 1rem 0;
                  font-size: 0.9rem;
                "
              >
                <ion-chip color="secondary">
                  <ion-icon name="library" slot="start"></ion-icon>
                  {{ insight.topics?.length || 0 }} topics
                </ion-chip>
                <ion-chip color="tertiary">
                  <ion-icon name="chatbubbles" slot="start"></ion-icon>
                  {{ getTotalConversationCount(insight) }} conversations
                </ion-chip>
                <ion-chip color="medium">
                  <ion-icon name="time" slot="start"></ion-icon>
                  {{ formatDateTime(insight.createdAt) }}
                </ion-chip>
              </div>

              <!-- Admin details section - expanded when selected -->
              <div *ngIf="selectedInsight?.id === insight.id">
                <!-- Compact Admin Info -->
                <ion-item lines="none">
                  <ion-label>
                    <p>
                      Project: {{ insight.projectId }} | Insight:
                      {{ insight.id }}
                    </p>
                  </ion-label>
                </ion-item>

                <!-- Topics List -->
                <div *ngIf="insight.topics && insight.topics.length > 0">
                  <ion-item lines="none">
                    <ion-label>
                      <h4>Topics & Conversations</h4>
                    </ion-label>
                  </ion-item>
                  <ion-item
                    *ngFor="let topic of insight.topics; let last = last"
                    [lines]="last ? 'none' : 'inset'"
                  >
                    <ion-icon
                      name="bookmark"
                      color="secondary"
                      slot="start"
                    ></ion-icon>
                    <ion-label>
                      <h3>
                        <a
                          [href]="getTopicDeepLink(topic)"
                          target="_blank"
                          rel="noopener"
                        >
                          {{ topic.topicTitle }}
                        </a>
                      </h3>
                      <p>{{ topic.topicDescription }}</p>
                      <p>
                        <em>{{ topic.context }}</em>
                      </p>
                      <ion-note>
                        Confidence:
                        {{ parseFloat(topic.confidence) | number: "1.2-2" }} |
                        {{ formatDateTime(topic.createdAt) }}
                      </ion-note>
                    </ion-label>
                    <div
                      slot="end"
                      style="display: flex; align-items: center; gap: 0.25rem"
                    >
                      <ion-button
                        *ngIf="getActionForTopic(insight, topic)"
                        fill="outline"
                        size="small"
                        color="success"
                        (click)="
                          executeTopicAction(
                            topic,
                            getActionForTopic(insight, topic)
                          )
                        "
                      >
                        <ion-icon name="create-outline" slot="start"></ion-icon>
                        {{
                          getActionButtonText(getActionForTopic(insight, topic))
                        }}
                      </ion-button>
                      <ion-button
                        *ngIf="getActionForTopic(insight, topic)"
                        fill="clear"
                        size="small"
                        color="medium"
                        (click)="
                          dismissTopicAction(
                            insight,
                            topic,
                            getActionForTopic(insight, topic)
                          )
                        "
                      >
                        <ion-icon name="close" slot="icon-only"></ion-icon>
                      </ion-button>
                      <a
                        [href]="getTopicDeepLink(topic)"
                        target="_blank"
                        rel="noopener"
                      >
                        <ion-button fill="clear" size="small" color="secondary">
                          <ion-icon name="bookmark"></ion-icon>
                        </ion-button>
                      </a>
                      <a
                        [href]="getConversationUrlForTopic(topic)"
                        target="_blank"
                        rel="noopener"
                      >
                        <ion-button fill="clear" size="small" color="primary">
                          <ion-icon name="chatbubble"></ion-icon>
                        </ion-button>
                      </a>
                    </div>
                  </ion-item>
                </div>
              </div>
            </ion-card-content>
          </ion-card>
        </div>
      </ion-col>
    </ion-row>

    <!-- Empty State -->
    <ion-row *ngIf="!isLoadingInsights && insights.length === 0">
      <ion-col>
        <div class="empty-state">
          <ion-card>
            <ion-card-content class="ion-text-center">
              <ion-icon
                name="bulb-outline"
                size="large"
                color="medium"
              ></ion-icon>
              <h3>No Knowledge Gap Insights</h3>
              <p>No insights found. This could mean:</p>
              <ul>
                <li>Your knowledge base is comprehensive</li>
                <li>No patterns have been detected yet</li>
                <li>Try adjusting your filters</li>
                <li>Or trigger a new analysis</li>
              </ul>
              <ion-button fill="outline" (click)="triggerAnalysis()">
                <ion-icon name="play" slot="start"></ion-icon>
                Trigger Analysis
              </ion-button>
            </ion-card-content>
          </ion-card>
        </div>
      </ion-col>
    </ion-row>

    <!-- Pagination Controls -->
    <ion-row
      *ngIf="!isLoadingInsights && insights.length > 0"
      class="pagination-container"
    >
      <ion-col>
        <div class="pagination-container">
          <ion-button
            fill="clear"
            [disabled]="!hasPreviousPage || currentPage <= 1"
            (click)="previousPage()"
          >
            <ion-icon name="chevron-back" slot="start"></ion-icon>
            Previous
          </ion-button>
          <span class="pagination-info">
            {{ insights.length }} insights
            <span *ngIf="totalInsights"> of {{ totalInsights }} </span>
          </span>
          <ion-button
            fill="clear"
            [disabled]="!hasNextPage"
            (click)="nextPage()"
          >
            Next
            <ion-icon name="chevron-forward" slot="end"></ion-icon>
          </ion-button>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
